import { createSlice } from "@reduxjs/toolkit"
import {
  addCatering,
  deleteCatering,
  getAllCaterings,
  updateCatering,
} from "store/actions/cateringAction"

const payloadInitialState = {
  limit: 50,
  page_number: 1,
  order_by: -1,
  filters: {
    is_trial_run: "all",
    keyword: "",
    date_range: {},
    status: "all",
  },
}
const initialState = {
  loading: false,
  isLoading: false,
  isGettingDetails: false,
  perPage: 50,
  totalPages: null,
  currentPage: null,
  totalCount: null,
  caterings: [],
  payload: payloadInitialState,
  isShowFilter: false,
}

const cateringSlice = createSlice({
  name: "Catering",
  initialState,
  reducers: {
    setPayload: (state, action) => {
      state.payload = { ...state.payload, ...action.payload }
    },
    resetPayload: state => {
      state.payload = payloadInitialState
    },
    toggleFilterVisibility: state => {
      state.isShowFilter = !state.isShowFilter
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getAllCaterings.pending, state => {
        state.loading = true
        state.totalPages = null
        state.totalCount = null
        state.currentPage = null
      })
      .addCase(getAllCaterings.fulfilled, (state, action) => {
        state.loading = false
        const { success, data } = action.payload
        if (success) {
          const { total_records, current_page, total_pages } =
            action.payload || {}
          state.caterings = data
          state.totalPages = total_pages
          state.totalCount = total_records
          state.currentPage = current_page
        }
      })
      .addCase(getAllCaterings.rejected, (state, action) => {
        state.loading = false
      })

    builder
      .addCase(addCatering.pending, state => {
        state.isLoading = true
      })
      .addCase(addCatering.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(addCatering.rejected, (state, action) => {
        state.isLoading = false
      })

    builder
      .addCase(updateCatering.pending, state => {
        state.isLoading = true
      })
      .addCase(updateCatering.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(updateCatering.rejected, (state, action) => {
        state.isLoading = false
      })

    builder
      .addCase(deleteCatering.pending, state => {
        state.isLoading = true
      })
      .addCase(deleteCatering.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(deleteCatering.rejected, (state, action) => {
        state.isLoading = false
      })
  },
})

export const { setPayload, resetPayload, toggleFilterVisibility } =
  cateringSlice.actions
export default cateringSlice.reducer
